import React from "react";

const WarningSign = ({size = 16}): React.ReactElement => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g id="warning-sign">
        <path
          id="warning-sign-icon"
          fillRule="evenodd"
          clipRule="evenodd"
          d="M0.666992 14.3337L8.00033 1.66699L15.3337 14.3337H0.666992ZM13.0203 13.0003L8.00034 4.327L2.98034 13.0003H13.0203ZM7.33366 11.0003V12.3337H8.66699V11.0003H7.33366ZM7.33366 7.00033H8.66699V9.66699H7.33366V7.00033Z"
          fill="#B6544C"
        />
      </g>
    </svg>
  );
};

export default WarningSign;
